import { IconButton, Typography, useTheme } from "@mui/material";
import { RotateCcw } from "lucide-react";
import type { FC } from "react";
import { ChatMessageAttachments } from "web_myplann/Chat/Components/ChatMessageAttachments";
import { ChatMessageBubble } from "web_myplann/Chat/Components/ChatMessageBubble";
import { formatChatTime } from "web_myplann/Chat/Helpers/chatFormatting";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	message: ChatMessageView;
	onRetry: (message: ChatMessageView) => void;
};

export const ChatSenderMessage: FC<Props> = ({ message, onRetry }) => {
	const theme = useTheme();
	const { t } = useResource();
	const { message: messageTheme, sender, timestamp } = theme.chat;
	const { content, attachments } = message;
	const showRetry = message.status === "failed";

	return (
		<ChatMessageBubble alignment="end" status={message.status}>
			<ChatMessageAttachments
				attachments={attachments}
				fileStyle={{
					backgroundColor: sender.attachmentBackground,
					color: sender.textColor,
				}}
			/>

			{content && (
				<Typography
					className="chat_bubble"
					variant="body2"
					color={sender.textColor}
					px={messageTheme.paddingX}
					py={messageTheme.paddingY}
					lineHeight={messageTheme.lineHeight}
					sx={{ background: sender.background }}
				>
					{content}
				</Typography>
			)}

			{showRetry && (
				<IconButton
					variant="ghost"
					onClick={() => onRetry(message)}
					aria-label={t(Resources.Chat.retry)}
				>
					<RotateCcw size={theme.iconSize.sm} color={theme.palette.grey[600]} />
				</IconButton>
			)}

			<Typography
				className="chat_group_tail"
				variant="hint"
				pr={timestamp.inset}
			>
				{formatChatTime(message.createdAt)}
			</Typography>
		</ChatMessageBubble>
	);
};
